import { apiClient } from "./apiClient";
import {
  ComplianceBusinessUnitSummary,
  ComplianceDirectReport,
  ComplianceOverview,
  CompliancePersonResource,
  CompliancePersonSummary,
  ComplianceResourceTypeSummary,
  ComplianceSnapshot,
} from "@/types/resourceCompliance";

export async function getComplianceSnapshots(): Promise<ComplianceSnapshot[]> {
  const res = await apiClient.get<ComplianceSnapshot[]>("/api/resource-compliance/snapshots");
  return res.data;
}

export async function getComplianceOverview(snapshotId: string): Promise<ComplianceOverview> {
  const res = await apiClient.get<ComplianceOverview>(`/api/resource-compliance/snapshots/${snapshotId}/overview`);
  return res.data;
}

export async function getComplianceBusinessUnitSummary(snapshotId: string): Promise<ComplianceBusinessUnitSummary[]> {
  const res = await apiClient.get<ComplianceBusinessUnitSummary[]>(`/api/resource-compliance/snapshots/${snapshotId}/bu-summary`);
  return res.data;
}

export async function getComplianceResourceTypeSummary(snapshotId: string): Promise<ComplianceResourceTypeSummary[]> {
  const res = await apiClient.get<ComplianceResourceTypeSummary[]>(`/api/resource-compliance/snapshots/${snapshotId}/resource-type-summary`);
  return res.data;
}

export async function getCompliancePersonSummary(snapshotId: string, email: string): Promise<CompliancePersonSummary> {
  const res = await apiClient.get<CompliancePersonSummary>(`/api/resource-compliance/snapshots/${snapshotId}/person/${encodeURIComponent(email)}`);
  return res.data;
}

export async function getComplianceDirectReports(snapshotId: string, email: string): Promise<ComplianceDirectReport[]> {
  const res = await apiClient.get<ComplianceDirectReport[]>(`/api/resource-compliance/snapshots/${snapshotId}/person/${encodeURIComponent(email)}/direct-reports`);
  return res.data;
}

export async function getCompliancePersonResources(snapshotId: string, email: string): Promise<CompliancePersonResource[]> {
  const res = await apiClient.get<CompliancePersonResource[]>(`/api/resource-compliance/snapshots/${snapshotId}/person/${encodeURIComponent(email)}/resources`);
  return res.data;
}

export async function emailResourceHealthSnapshots(personEmail: string, snapshotIds: string[]): Promise<{ recipientEmail: string; message: string }> {
  const res = await apiClient.post<{ recipientEmail: string; message: string }>("/api/resource-compliance/demo/email", { personEmail, snapshotIds });
  return res.data;
}
